import { useEffect, useState } from "react";
import styles from "./HomesteadExemptionPage.module.css";
import { HomesteadSuccessModal } from "../SucessModal/HomesteadSuccessModal";
import { useHomesteadExemptionViewModal } from "@/features/homesteadExemption/viewModal/homesteadExemptionViewModal";
import { Modal } from "@/shared/modal";

export const HomesteadExemptionPage = () => {
  const vm = useHomesteadExemptionViewModal(styles);
  const [consentAccepted, setConsentAccepted] = useState(false);
  const [checkoutConsentAccepted, setCheckoutConsentAccepted] = useState(false);
  const isAlreadyFiled =
    vm.propertyDetails?.homestead_status !== "not_filed" &&
    vm.propertyDetails?.homestead_status !== null;

  useEffect(() => {
    if (!vm.isSignModalOpen) {
      setConsentAccepted(false);
    }
  }, [vm.isSignModalOpen]);

  const signModalTitle = vm.propertyDetails?.homestead_signed
    ? "Signed Homestead Documents"
    : "Provide Digital Signature";

  const signModalBody = vm.propertyDetails?.homestead_signed ? (
    <div className={styles.documentsGridSingle}>
      <div className={styles.documentPanel}>
        <div className={styles.documentTitle}>Homestead Document</div>
        {vm.homesteadDocUrl ? (
          <iframe
            title="Homestead Document"
            src={vm.homesteadDocUrl}
            className={styles.documentFrame}
          />
        ) : (
          <div className={styles.documentEmpty}>Document preview unavailable.</div>
        )}
      </div>
    </div>
  ) : (
    <div className={styles.signatureSection}>
      <div className={styles.signatureHeaderBlock}>
        <div className={styles.signatureTitle}>Your Signature</div>
        <p className={styles.signatureSubtitle}>
          Please sign below to complete your Homestead / Over 65 Exemption documents.
        </p>
        <ul className={styles.signatureBullets}>
          <li>Creates your Homestead / Over 65 Exemption application with the county.</li>
          <li>Completes the required forms for exemption filing.</li>
          <li>Helps reduce your property tax burden through legal exemptions.</li>
        </ul>
      </div>

      <div className={styles.filingBlock}>
        <div className={styles.filingTitle}>Property Tax Exemption Filing</div>
        <div className={styles.docsToSign}>
          <div className={styles.docsToSignTitle}>Documents to Sign</div>
          <p className={styles.docsToSignSubtitle}>
            Your signature will be used to complete the following required documents:
          </p>

          <div className={styles.docList}>
            <div className={styles.docItem}>
              <span className={styles.docIcon} aria-hidden="true">
                🏠
              </span>
              <div className={styles.docText}>
                <div className={styles.docName}>Homestead / Over 65 Exemption Application</div>
                <div className={styles.docDesc}>
                  Your official application for homestead and over 65 tax exemptions with the
                  county.
                </div>
              </div>
            </div>

            <div className={styles.docItem}>
              <span className={styles.docIcon} aria-hidden="true">
                📄
              </span>
              <div className={styles.docText}>
                <div className={styles.docName}>Exemption Filing Agreement</div>
                <div className={styles.docDesc}>
                  Agreement for filing your exemption application with the appropriate authorities.
                </div>
              </div>
            </div>
          </div>

          {/* <div className={styles.docsNote}>
                  We can prefill these documents with your information to save you time.
                </div> */}
        </div>
      </div>

      <div className={styles.signatureCanvasTitle}>Digital Signature</div>
      <canvas
        ref={vm.signatureCanvasRef}
        className={styles.signatureCanvas}
        onMouseDown={vm.startDrawing}
        onMouseMove={vm.draw}
        onMouseUp={vm.stopDrawing}
        onMouseLeave={vm.stopDrawing}
        onTouchStart={vm.startDrawing}
        onTouchMove={vm.draw}
        onTouchEnd={vm.stopDrawing}
      />
      <div className={styles.signatureActions}>
        <label className={styles.consentRow} htmlFor="homestead-sign-consent">
          <input
            id="homestead-sign-consent"
            type="checkbox"
            className={styles.consentCheckbox}
            checked={consentAccepted}
            onChange={(event) => setConsentAccepted(event.target.checked)}
          />
          <span className={styles.consentText}>
            I agree to exemption to filing terms &amp; authorize The Andy App to process my
            Homestead/Over 65 Exemption application
          </span>
        </label>
        <button type="button" className={styles.clearBtn} onClick={vm.clearSignature}>
          Clear
        </button>
        <button
          type="button"
          className={styles.signBtn}
          onClick={() => void vm.handleSubmitSignature()}
          disabled={!vm.signature || vm.isSubmittingSignature || !consentAccepted}
        >
          {vm.isSubmittingSignature ? "Submitting..." : "Submit Signature"}
        </button>
      </div>
    </div>
  );

  return (
    <section className={styles.page}>
      <div className={styles.container}>
        <div className={styles.topBar}>
          <button type="button" className={styles.backButton} onClick={vm.onBack}>
            ← Back
          </button>
        </div>
        <h1 className={styles.title}>Homestead Exemption</h1>

        <div className={styles.addressCard}>
          <div className={styles.mapPreview} aria-hidden="true" />

          <div className={styles.addressBody}>
            <div className={styles.addressTitle}>
              {vm.isPropertyLoading ? "Loading property..." : vm.propertyAddressTitle}
            </div>
            <div className={styles.addressMeta}>
              {vm.isPropertyLoading
                ? "Please wait..."
                : vm.propertyAddressMeta || vm.propertyId || "No property selected"}
            </div>
            <ul className={styles.addressList}>
              <li>Primary Residence</li>
              <li>Eligible for Homestead / Over 65</li>
            </ul>
          </div>

          <button
            type="button"
            className={styles.viewBtn}
            onClick={() => vm.setIsSignModalOpen(true)}
          >
            {vm.propertyDetails?.homestead_signed
              ? "View Signed Homestead/Over 65 Exemption"
              : "Sign Homestead/Over 65 Exemption"}
          </button>
        </div>

        <div className={styles.grid}>
          <div>
            <h2 className={styles.sectionTitle}>Upload your Driver&apos;s License Images</h2>
            <p className={styles.sectionSubTitle}>
              Your address on the license must match the property address.
            </p>

            <div className={styles.uploadRow}>
              <button
                type="button"
                className={styles.uploadBox}
                onClick={() => vm.frontInputRef.current?.click()}
                disabled={vm.isUploadingFront}
              >
                {vm.licenseFrontPhoto ? (
                  <img
                    src={vm.licenseFrontPhoto}
                    alt="Front license preview"
                    className={styles.licensePreview}
                  />
                ) : vm.isUploadingFront ? (
                  "Uploading..."
                ) : (
                  vm.frontFileName || "Front of License"
                )}
              </button>
              <button
                type="button"
                className={styles.uploadBox}
                onClick={() => vm.backInputRef.current?.click()}
                disabled={vm.isUploadingBack}
              >
                {vm.licenseBackPhoto ? (
                  <img
                    src={vm.licenseBackPhoto}
                    alt="Back license preview"
                    className={styles.licensePreview}
                  />
                ) : vm.isUploadingBack ? (
                  "Uploading..."
                ) : (
                  vm.backFileName || "Back of License"
                )}
              </button>
              <input
                ref={vm.frontInputRef}
                type="file"
                className={styles.hiddenInput}
                accept="image/*,.pdf,.doc,.docx"
                onChange={(event) => void vm.handleUpload("front", event.target.files?.[0] ?? null)}
              />
              <input
                ref={vm.backInputRef}
                type="file"
                className={styles.hiddenInput}
                accept="image/*,.pdf,.doc,.docx"
                onChange={(event) => void vm.handleUpload("back", event.target.files?.[0] ?? null)}
              />
            </div>

            <div className={styles.whyCard}>
              <div className={styles.whyTitle}>Why this works</div>
              <ul className={styles.whyList}>
                <li>Filed directly with county offices</li>
                <li>One-time filing (no recurring fees)</li>
                <li>Saves you real property tax money</li>
              </ul>
            </div>
          </div>

          <aside className={styles.summaryCard}>
            <h3 className={styles.summaryTitle}>Exemption Filing Summary</h3>
            <div className={styles.summaryRow}>
              <span>Property</span>
              <span>{vm.isPropertyLoading ? "Loading..." : vm.propertyAddressTitle}</span>
            </div>
            <div className={styles.summaryRow}>
              <span>Exemption</span>
              <span>Homestead / Over 65</span>
            </div>
            <div className={styles.summaryRow}>
              <span>County Filing Fee:</span>
              <span>Included</span>
            </div>
            {!isAlreadyFiled ? (
              <div className={styles.totalRow}>
                <span>Total</span>
                <strong>$149</strong>
              </div>
            ) : null}
            {isAlreadyFiled ? (
              <>
                <div className={styles.alreadyFiledMessage}>
                  Homestead/Over 65 Exemption has already been filed for this property
                </div>
                <button
                  type="button"
                  className={styles.checkoutBtn}
                  onClick={() => {
                    // Even if server says it's filed, require required local steps before continuing.
                    const hasFront = Boolean(vm.licenseFrontPhoto);
                    const hasBack = Boolean(vm.licenseBackPhoto);
                    const hasSigned = vm.propertyDetails?.homestead_signed;
                    if (!hasFront) {
                      window.alert(
                        "Please upload the FRONT of your driver’s license before continuing."
                      );
                      return;
                    }
                    if (!hasBack) {
                      window.alert(
                        "Please upload the BACK of your driver’s license before continuing."
                      );
                      return;
                    }
                    if (!hasSigned) {
                      vm.setIsSignModalOpen(true);
                      window.alert("Please sign the homestead documents before continuing.");
                      return;
                    }
                    vm.navigate(vm.routes.homepage);
                  }}
                >
                  Continue
                </button>
              </>
            ) : (
              <>
                <label
                  className={`${styles.consentRow} ${styles.checkoutConsentRow}`}
                  htmlFor="homestead-checkout-consent"
                >
                  <input
                    id="homestead-checkout-consent"
                    type="checkbox"
                    className={styles.consentCheckbox}
                    checked={checkoutConsentAccepted}
                    onChange={(event) => setCheckoutConsentAccepted(event.target.checked)}
                  />
                  <span className={styles.consentText}>
                    I Confirm that the Information provided is accurate, and I agree to Excemption
                    Filing agreement
                  </span>
                </label>
                <button
                  type="button"
                  className={styles.checkoutBtn}
                  onClick={() => void vm.onStartCheckout()}
                  disabled={vm.isPaymentProcessing || !checkoutConsentAccepted}
                >
                  Checkout
                </button>
              </>
            )}
          </aside>
        </div>
      </div>

      <Modal
        isOpen={vm.isSignModalOpen}
        onClose={() => vm.setIsSignModalOpen(false)}
        unconstrained
        className={styles.modalCard}
        headerClassName={styles.modalHeader}
        title={signModalTitle}
        titleClassName={styles.modalTitle}
        bodyClassName={styles.modalCardBody}
        ariaLabel="Sign homestead documents"
      >
        {signModalBody}
      </Modal>

      {vm.paymentModal}

      <HomesteadSuccessModal
        isOpen={vm.isSuccessOpen}
        onClose={() => vm.setIsSuccessOpen(false)}
        onDone={() => vm.navigate(vm.routes.homepage)}
      />
    </section>
  );
};
